(function () {
  'use strict';

  var SCROLL_THRESHOLD = 30; // pixels from bottom to consider "scrolled to end"

  /**
   * Uses event delegation on `document` so that dynamically-replaced
   * checkout buttons (e.g. after cart drawer re-render) are always caught.
   */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-terms-checkout-trigger]');
    if (!trigger) return;

    e.preventDefault();
    e.stopPropagation();
    openModal();
  }, true); // useCapture = true to intercept before any other handler

  function getOverlay() {
    return document.getElementById('termsModalOverlay');
  }

  function openModal() {
    var overlay = getOverlay();
    if (!overlay) return;

    var content = overlay.querySelector('.terms-modal__content');
    var agreeBtn = overlay.querySelector('.terms-modal__agree-btn');
    var progressFill = overlay.querySelector('.terms-modal__progress-fill');
    var scrollHint = overlay.querySelector('.terms-modal__scroll-hint');

    // Reset state each time modal opens
    content.scrollTop = 0;
    agreeBtn.disabled = true;
    if (progressFill) progressFill.style.width = '0%';
    if (scrollHint) scrollHint.classList.remove('is-hidden');

    overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';

    // Check if content is already fully visible (no scrolling needed)
    requestAnimationFrame(function () {
      checkScrollPosition(overlay);
    });
  }

  function closeModal() {
    var overlay = getOverlay();
    if (!overlay) return;
    overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  function checkScrollPosition(overlay) {
    if (!overlay) overlay = getOverlay();
    if (!overlay) return;

    var content = overlay.querySelector('.terms-modal__content');
    var agreeBtn = overlay.querySelector('.terms-modal__agree-btn');
    var progressFill = overlay.querySelector('.terms-modal__progress-fill');
    var scrollHint = overlay.querySelector('.terms-modal__scroll-hint');

    var scrollTop = content.scrollTop;
    var scrollHeight = content.scrollHeight;
    var clientHeight = content.clientHeight;
    var maxScroll = scrollHeight - clientHeight;

    // Update progress bar
    if (progressFill && maxScroll > 0) {
      var progress = Math.min((scrollTop / maxScroll) * 100, 100);
      progressFill.style.width = progress + '%';
    }

    // If content fits without scrolling, or user scrolled to the bottom
    if (maxScroll <= 5 || (maxScroll - scrollTop) <= SCROLL_THRESHOLD) {
      agreeBtn.disabled = false;
      if (scrollHint) scrollHint.classList.add('is-hidden');
      if (progressFill) progressFill.style.width = '100%';
    }
  }

  // --- Event listeners that use delegation or the static modal element ---

  // Close button (delegation on overlay)
  document.addEventListener('click', function (e) {
    var overlay = getOverlay();
    if (!overlay || !overlay.classList.contains('is-visible')) return;

    // Close button
    if (e.target.closest('.terms-modal__close')) {
      closeModal();
      return;
    }

    // Click on overlay backdrop (not the modal itself)
    if (e.target === overlay) {
      closeModal();
      return;
    }

    // Agree button
    var agreeBtn = e.target.closest('.terms-modal__agree-btn');
    if (agreeBtn && !agreeBtn.disabled) {
      closeModal();
      window.location.href = '/checkout';
      return;
    }
  });

  // Escape key to close
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var overlay = getOverlay();
      if (overlay && overlay.classList.contains('is-visible')) {
        closeModal();
      }
    }
  });

  // Scroll detection inside terms content (delegation)
  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('terms-modal__content')) {
      checkScrollPosition();
    }
  }, true); // useCapture to catch scroll on nested element

})();
